// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthReservation\ApiBerthReservationSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { BerthReservationVersion, BerthReservationVersionData, BerthReservationVersionOptions } from 'data/models/BerthReservationVersion';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { ItineraryPointSelf, ItineraryPointSelfData, ItineraryPointSelfOptions } from 'data/models/ItineraryPointSelf';

// BerthReservationSelfData is the class that BerthReservationSelf serializes to/from
export interface BerthReservationSelfData {
    Id : number;
	
    Events : EventData[] | null;
    Itinerary : ItineraryPointSelfData | null;
    Live : BerthReservationData | null;
    Versions : BerthReservationVersionData[] | null;
	
}

// BerthReservationSelfOptions is the class which may be passed to the BerthReservationSelf constructor to define optional initial data values
export interface BerthReservationSelfOptions {
    Id : number;
	
    Events? : EventOptions[] | null;
    Itinerary? : ItineraryPointSelfOptions | null;
    Live? : BerthReservationOptions | null;
    Versions? : BerthReservationVersionOptions[] | null;
	
}

export class BerthReservationSelf {
    public Id : DataSignal<number>;
	
    public Events : SDataArray<Event>;
    public Itinerary : DataSignal<ItineraryPointSelf | null>;
    public Live : DataSignal<BerthReservation | null>;
    public Versions : SDataArray<BerthReservationVersion>;
	

    constructor();
    constructor(data : BerthReservationSelfOptions);
    constructor(data: BerthReservationSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Events = SArray<Event>([]);
        this.Itinerary = S.value<ItineraryPointSelf | null>(null);
        this.Live = S.value<BerthReservation | null>(null);
        this.Versions = SArray<BerthReservationVersion>([]);
	    
    }

    static key(obj : BerthReservationSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthReservationSelfOptions) {
        return obj.Id;
    }

    static update(obj : BerthReservationSelf, data : BerthReservationSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthReservationSelf.ts